import axios from "axios";
import { useMutation } from "react-query";
import { END_POINT } from "config/environment";
import { IJobsProps } from "../types";

export const createJob = async (props: IJobsProps) => {
  const corporate_id = props?.userInfo?.current_team
    ? props?.userInfo?.current_team.corporate_id
    : "";

  const hasListingId =
    props.id !== undefined &&
    props.id !== null &&
    String(props.id).trim() !== "";

  const url = hasListingId
    ? `${END_POINT.BASE_URL}/v1/update-jobs`
    : `${END_POINT.BASE_URL}/v1/jobs`;

  const config = {
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${props.token}`,
    },
  };

  const data: Record<string, unknown> = {
    recruiter_id: props.recruiter_id,
    corporate_id: corporate_id,
    description: props.description,
    title: props.title,
    sector_id: props.sector_id,
    company_name: props.company_name,
    type: props.type,
    level: props.level,
    language: props.language,
    expiry_date: props.expiry_date,
    years_of_experience: props.years_of_experience,
    location_id: props.location_id,
    location_city: props.location_city,
    location_country: props.location_country,
    skills: props.skills,
    employment_type: props.employment_type,
    status: props.status,
    created_at: props.created_at,
    social_auto_post: props.social_auto_post,
    social_platforms: props.social_platforms,
  };

  if (hasListingId) {
    data.id = props.id;
  }

  const response = await axios.post(url, data, config);
  return response;
};

export const useCreateJob = () => {
  return useMutation(createJob);
};
